
import React, { useContext, useState } from "react";
import { AppContext } from "../../../../../appContext";
import { PopupWrapper } from "../../../../../components/styled/BasicBlocks";
import { SideMenuAdminInfo } from "./SideMenuAdminInfo";
import { SideMenuAdminUsers } from "./SideMenuAdminUsers";
import { SideMenuAdminCreate } from "./SideMenuAdminCreate";
import { SideMenuAdminReports } from "./SideMenuAdminReports";
import "./SideMenuAdministrator.css";

export const SideMenuAdministrator = ({ onClose }: { onClose: () => void }) => {
    const { translate } = useContext(AppContext);
    const [activeTab, setActiveTab] = useState(() => {
        // Remember the last active admin tab
        return localStorage.getItem('adminActiveTab') || 'info';
    });

    const tabs = {
        info: SideMenuAdminInfo,
        users: SideMenuAdminUsers,
        create: SideMenuAdminCreate,
        reports: SideMenuAdminReports
    };

    const ActiveComponent = tabs[activeTab as keyof typeof tabs];

    return <PopupWrapper className="SideMenuAdministrator">
        <div className="SideMenuAdministrator_tabs">
            <div 
                className={`SideMenuAdministrator_tab ${activeTab === 'info' ? 'active' : ''}`}
                onClick={() => {
                    setActiveTab('info');
                    localStorage.setItem('adminActiveTab', 'info');
                }}
            >
                {translate('admin_tab_info')}
            </div>
            <div 
                className={`SideMenuAdministrator_tab ${activeTab === 'users' ? 'active' : ''}`}
                onClick={() => {
                    setActiveTab('users');
                    localStorage.setItem('adminActiveTab', 'users');
                }}
            >
                {translate('admin_tab_users')}
            </div>
            <div 
                className={`SideMenuAdministrator_tab ${activeTab === 'create' ? 'active' : ''}`}
                onClick={() => {
                    setActiveTab('create');
                    localStorage.setItem('adminActiveTab', 'create');
                }}
            >
                {translate('admin_tab_create')}
            </div>
            <div 
                className={`SideMenuAdministrator_tab ${activeTab === 'reports' ? 'active' : ''}`}
                onClick={() => {
                    setActiveTab('reports');
                    localStorage.setItem('adminActiveTab', 'reports');
                }}
            >
                {translate('admin_tab_reports')}
            </div>
        </div>
        <ActiveComponent onClose={onClose} />
    </PopupWrapper>
}
